import { ComponentProps, ReactNode } from 'react'

import cn from '@/utilities/cn'

type StatusIndicatorProps = {
  variant?: 'success' | 'error' | 'warning' | 'info' | 'default'
  label?: ReactNode
  ping?: boolean
}
export default function StatusIndicator({
  variant = 'default',
  label,
  ping = false,
  className,
  ...rest
}: StatusIndicatorProps & ComponentProps<'div'>) {
  return (
    <div className={cn('flex items-center gap-x-3', className)} {...rest}>
      <div
        className={cn(
          'absolute h-2 w-2 rounded-full',
          { 'animate-ping duration-150': ping },
          {
            'bg-emerald-400': variant === 'success',
            'bg-red-400': variant === 'error',
            'bg-yellow-400': variant === 'warning',
            'bg-blue-400': variant === 'info',
            'bg-zinc-400': variant === 'default'
          }
        )}
      />
      <div
        className={cn('relative inline-flex h-2 w-2 rounded-full', {
          'bg-emerald-500': variant === 'success',
          'bg-red-500': variant === 'error',
          'bg-yellow-500': variant === 'warning',
          'bg-blue-500': variant === 'info',
          'bg-zinc-500': variant === 'default'
        })}
      />
      <div className="text-sm">{label}</div>
    </div>
  )
}
